var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized"
            }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "d-flex border-bottom align-items-center mHeader" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "p-3",
                  on: {
                    click: function($event) {
                      return _vm.closeNavigation()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-close" })]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" }
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _vm._m(6)
            ]
          )
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized ? [_c("loading-animation")] : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-fill" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn02.plentymarkets.com/9jjwc76la94e/frontend/Webseite/spotlight-dev-50.png",
          alt: "Spotlight-dev",
          title: "Spotlight-dev"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "ddown" }, [
      _c("a", { attrs: { href: "/" } }, [_vm._v("Startseite")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "ddown" }, [
      _c("a", { attrs: { href: "/produkte/" } }, [_vm._v("Produkte")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "ddown" }, [
      _c("a", { attrs: { href: "/ueber-uns/" } }, [_vm._v("Über uns")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "ddown" }, [
      _c("a", { attrs: { href: "/kontakt/" } }, [_vm._v("Kontakt")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "ddown" }, [
      _c("a", { attrs: { href: "https://wiki.spotlight-dev.de/de/home" } }, [
        _c("span", { staticClass: "badge" }, [_vm._v("Neu")]),
        _vm._v("\n            Wiki\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "ddown" }, [
      _c("a", { attrs: { href: "/kunden-login/" } }, [_vm._v("Kunden Login")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }